import React from 'react';
import { motion } from 'framer-motion';
export function TheAskSection() {
  return <section id="ask" className="pt-10 pb-16 relative" data-id="element-135">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} data-id="element-136">
        <div className="mb-8 relative" data-id="element-137">
          <h2 className="text-5xl md:text-6xl font-bold mb-3 tracking-tight" data-id="element-138">
            HOW YOU CAN HELP
          </h2>
          <div className="flex gap-2 mt-4" data-id="element-139">
            {['#FF0000', '#FF8800', '#FFDD00', '#00DD00', '#0088FF', '#8800FF'].map((color, i) => <div key={i} className="h-2 flex-1" style={{
            backgroundColor: color
          }} data-id="element-140" />)}
          </div>
        </div>
        <div className="border-4 border-black p-6 bg-white mb-6 relative" data-id="element-141">
          <div className="space-y-4 text-base leading-relaxed" data-id="element-142">
            <p className="font-bold text-lg" data-id="element-143">
              This is a movement, a company, a creative rebellion, and a
              business model — all at once.
            </p>
            <p data-id="element-144">
              If I don't build this movement, someone less ethical will. The
              future belongs to communities, not platforms.
            </p>
            <p data-id="element-145">
              I want to mix activism, art, and tech into something ethical and
              profitable — no compromises.
            </p>
            <p className="font-bold" style={{
            color: '#8800FF'
          }} data-id="element-146">
              I'm here to build safety, confidence, purpose and financial
              stability — in public, with humor.
            </p>
          </div>
        </div>
        <div className="grid md:grid-cols-3 gap-4 mb-8" data-id="element-147">
          {[{
          title: 'MENTORSHIP',
          desc: "You've built ethical businesses. You can open doors. Share what you've learned. Help me avoid the mistakes you made.",
          icon: '💡',
          color: '#0088FF',
          commitment: 'TIME & INTRODUCTIONS'
        }, {
          title: 'SUPPORT',
          desc: 'You believe in this mission. Sliding scale donations help me keep building without selling out. Every bit matters.',
          icon: '🤝',
          color: '#00DD00',
          commitment: '$500-$5,000'
        }, {
          title: 'INVESTMENT',
          desc: 'After Kickstarter proves demand. Join the F&F round. Be part of building infrastructure that puts creators first.',
          icon: '💰',
          color: '#8800FF',
          commitment: '$25,000+'
        }].map((item, i) => <motion.div key={i} className="border-4 border-black bg-white overflow-hidden relative" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} data-id="element-148">
              <div className="p-3 text-center" style={{
            backgroundColor: item.color
          }} data-id="element-149">
                <div className="text-3xl mb-1" data-id="element-150">{item.icon}</div>
                <h3 className="text-lg font-bold" data-id="element-151">{item.title}</h3>
              </div>
              <div className="p-5" data-id="element-152">
                <p className="text-sm mb-3" data-id="element-153">{item.desc}</p>
                <div className="border-t-2 border-black pt-3" data-id="element-154">
                  <div className="text-xs font-bold text-center" data-id="element-155">
                    {item.commitment}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
        <div className="border-4 border-black p-6 bg-white text-black mb-8 relative" data-id="element-156">
          <h3 className="text-xl font-bold mb-4" data-id="element-157">
            WANT IN ON THE FRIENDS & FAMILY ROUND?
          </h3>
          <div className="space-y-4 mb-6" data-id="element-158">
            {[{
            step: '1',
            text: "Email me. Tell me why you believe in this — not just the business, but the mission. I want angels who get what we're building here.",
            color: '#00DD00'
          }, {
            step: '2',
            text: "We'll hop on a call. I want to understand your story, what drives you, why backing ethical creator infrastructure matters to you.",
            color: '#0088FF'
          }, {
            step: '3',
            text: "If it clicks, you're in. $25,000+. Early access. Direct line to me. You help shape what comes next.",
            color: '#8800FF'
          }].map((item, i) => <div key={i} className="flex items-start" data-id="element-159">
                <div className="w-8 h-8 flex items-center justify-center font-bold text-black mr-3 flex-shrink-0 text-sm border-2 border-black" style={{
              backgroundColor: item.color
            }} data-id="element-160">
                  {item.step}
                </div>
                <span className="text-base leading-relaxed" data-id="element-161">{item.text}</span>
              </div>)}
          </div>
          <motion.a href="https://tally.so/r/w4d6Qd" target="_blank" rel="noopener noreferrer" className="w-full py-4 text-black font-bold text-base border-4 border-black relative overflow-hidden block text-center no-underline" style={{
          backgroundColor: '#8800FF'
        }} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} data-id="element-162">
            BACK THIS VISION
          </motion.a>
        </div>
      </motion.div>
    </section>;
}